export default "/assets/images/waving-hand.png?90b025558981c8ce171c148487b6d462";